import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export interface SmartListFilter {
  subscriptionStatus?: string[];
  marketingConsent?: boolean;
  weeklyTipsSubscribed?: boolean;
  registeredWithinDays?: number;
  registeredBeforeDays?: number;
  hasNoActiveSubscription?: boolean;
  neverSubscribed?: boolean;
}

export interface SmartListPreviewUser {
  email: string;
  firstName: string;
  lastName: string;
  subscriptionStatus: string | null;
  marketingConsent: boolean;
  weeklyTipsSubscribed: boolean;
  createdAt: string;
}

export interface SmartListPreviewResult {
  count: number;
  users: SmartListPreviewUser[];
  truncated: boolean;
}

export interface SmartListPushResult {
  listId: number;
  added: number;
  failed: number;
  /** Matched customers left off the list because they have not opted in to marketing. */
  excludedWithoutConsent: number;
}

export function usePreviewSmartList() {
  return useMutation({
    mutationFn: (filter: SmartListFilter) =>
      apiClient<SmartListPreviewResult>('/brevo/smart-lists/preview', { method: 'POST', body: JSON.stringify({ filter }) }),
  });
}

export function usePushSmartList() {
  return useMutation({
    mutationFn: (input: { filter: SmartListFilter; brevoListId?: number; newListName?: string; folderId?: number }) =>
      apiClient<SmartListPushResult>('/brevo/smart-lists/push', { method: 'POST', body: JSON.stringify(input) }),
  });
}
